export const SEARCH_TIME_LAPSE = 400

let debounceTimeoutId = null
export const throttleSearch = async (callback, interval = SEARCH_TIME_LAPSE) => {
  clearTimeout(debounceTimeoutId)
  debounceTimeoutId = setTimeout(() => callback(), interval)
}
